import { NgModule } from '@angular/core';
import { NzIconModule, NZ_ICONS } from 'ng-zorro-antd';
import { EyeInvisibleOutline, EyeOutline, CloseOutline, WarningFill, InfoCircleOutline, NotificationFill, CalendarOutline, ShareAltOutline, BookOutline, LockOutline, GlobalOutline, CaretDownFill, CaretUpFill, SearchOutline, HeartFill, HeartOutline, ArrowLeftOutline, PlusCircleFill, EditOutline, RightOutline, DownOutline, UpOutline, CloseCircleOutline, PlayCircleFill, QuestionCircleOutline } from '@ant-design/icons-angular/icons';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ngz-icon.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
const NZ_ICONS_USED_BY_LIB = [
    EyeInvisibleOutline,
    EyeOutline,
    CloseOutline,
    WarningFill,
    InfoCircleOutline,
    NotificationFill,
    CalendarOutline,
    ShareAltOutline,
    BookOutline,
    LockOutline,
    GlobalOutline,
    CaretDownFill,
    CaretUpFill,
    SearchOutline,
    HeartFill,
    HeartOutline,
    ArrowLeftOutline,
    PlusCircleFill,
    EditOutline,
    RightOutline,
    DownOutline,
    UpOutline,
    CloseCircleOutline,
    PlayCircleFill,
    QuestionCircleOutline
];
class B2CNgzIconModule {
}
B2CNgzIconModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CNgzIconModule });
B2CNgzIconModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CNgzIconModule_Factory(t) { return new (t || B2CNgzIconModule)(); }, providers: [{ provide: NZ_ICONS, useValue: NZ_ICONS_USED_BY_LIB }], imports: [[NzIconModule],
        NzIconModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CNgzIconModule, { imports: function () { return [NzIconModule]; }, exports: function () { return [NzIconModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CNgzIconModule, [{
        type: NgModule,
        args: [{
                imports: [NzIconModule],
                exports: [NzIconModule],
                providers: [{ provide: NZ_ICONS, useValue: NZ_ICONS_USED_BY_LIB }]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-ngz-icons.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CNgzIconModule, NZ_ICONS_USED_BY_LIB };


//# sourceMappingURL=b2c-ui-ngz-icons.js.map